<pcg-resizable-widget showFacility="true">
    <span widget-title>Rx Requests</span>
    <div 
        class="rx-actions w-100" 
        [class.disabled-actions]="disabledScan()"
        widget-subheader
    >
        <button
            class="btn-primary text-truncate"
            [class.btn-secondary]="disabledScan()"
            (click)="newRefill()"
            [pTooltip]="buttonText()"
            [disabled]="disabledScan()"
        >            
            <i class="pi"
                [class.pi-plus]="!isProcessesing()"
                [class.pi-spinner]="isProcessesing()"
                [class.pi-spin]="isProcessesing()"
            ></i>
            <span class="text-center text-truncate">
                {{ buttonText() }}
            </span>
        </button>
        @if (!disabledScan()) {
            <input 
                #rxNumber
                class="input-rx" 
                type="text" 
                placeholder="Rx Number…"
                [(ngModel)]="rxNumberInput"
                (keydown.enter)="newRefill()"
                [disabled]="disabledScan()"
            />              
        }
    </div>
    <div 
        class="h-100" 
        (scroll)="onScroll($event)"
        widget-body
    >
        @if (
            fetching() 
            && page() == 1
        ) {
            <div class="mt-2 pb-1 text-center">
                <span 
                    class="spinner-border spinner-border-sm align-middle mr-1" 
                    role="status" 
                    aria-hidden="true"
                ></span>
                Finding Recent Refills...
            </div>
        } @else {
            @for (refill of recentRefills(); track refill.shipmentId) {
                <pcg-link 
                    class="rx-item" 
                    [href]="redirect(refill)"
                >
                    <div style="display:flex; flex-direction:column; gap:3px; flex:1;">
                        <div style="display:flex; align-items:center; gap:10px;">
                            <span class="rx-number">{{ refill.shipmentId }}</span>
                            <span class="rx-step-badge">{{ convertStepName(refill.currentStep) }}</span>
                        </div>
                        <span style="font-size:11px; color:#9aabba; font-family:'DM Mono',monospace;">{{ refill.dateCreated | utcToLocal | timeAgo }}</span>
                    </div>
                    <div class="rx-notif-dot">{{ refill.rxCount }}</div>
                </pcg-link>
            } @empty { <div class="text-center text-muted py-3">No recent Refills</div> }
        }
    </div>
</pcg-resizable-widget>